import { Box, Button } from '@mui/material'
import { loadSmplrJs } from '@smplrspace/smplr-loader'
import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'

const BuildingHeatMap = () => {
    const [smplr, setSmplr] = useState()
    const [viewerReady, setViewerReady] = useState(false)
    const [selectedHeatmapType, setSelectedHeatmaptype] = useState('temp')
    const spaceId = 'a1f4d80b-48bc-4a1b-89ea-7bd1a7613d24'
    const spaceRef = useRef();
    const { siteId } = useParams();

    const SwitchHeatmapTypeTemp = () => {
        setSelectedHeatmaptype('temp')
    }

    const SwitchHeatmapTypeCo2 = () => {
        setSelectedHeatmaptype('co2')
    }

    // Load smplr 
    useEffect(() => {
        loadSmplrJs('EMS').then((smplr) => {
            setSmplr(smplr)
        })
        .catch((error) => console.log(error))
    }, [])

    // Create space instance
    useEffect(() => {
        if (smplr) {
            spaceRef.current = new smplr.Space({
                spaceId: spaceId,
                clientToken: 'pub_51fc39f6ab424c228b0e11782e052413',
                containerId: 'test',
            })
            spaceRef.current.startViewer({
                preview: false,
                loadingMessage:`Weergave wordt gestart`,
                onReady: () => {
                  setViewerReady(true);
                },
                onError: (e) => console.error('could not start viewer' + e),
              })
        }
    }, [smplr])

    useEffect(() => {
        if (spaceRef.current) {
            spaceRef.current.remove();
        }
    }, [siteId])

  return (
    <Box m='18px' sx={{maxWidth:'100%'}}>
        <Box sx={{marginBottom:'18px', display:'flex', justifyContent:'space-between', width:'150px'}}>
            <Button variant='contained' onClick={() => SwitchHeatmapTypeTemp()} sx={{backgroundColor: selectedHeatmapType === 'temp' ? ('#04eb83') : ('inherit'), color:'black', '&:hover':{backgroundColor:'#AAAAAA'}}}>Temp</Button>
            <Button variant='contained' onClick={() => SwitchHeatmapTypeCo2()} sx={{backgroundColor: selectedHeatmapType === 'co2' ? ('#04eb83') : ('inherit'), color:'black', '&:hover':{backgroundColor:'#AAAAAA'}}}>Co2</Button>
            <Button variant='contained'>{viewerReady}</Button>
        </Box>
        <Box sx={{display:'flex'}}>
        <div id='test' style={{width:'65%', height:'800px'}}/>
        </Box>
    </Box>
  )
}

export default BuildingHeatMap
